/**
 * Collapsible "How It Works" guide panel for module pages.
 * Displays a numbered step-by-step overview in a responsive grid.
 */
import React, { useState } from 'react';

export default function HowItWorksGuide({ moduleName, steps, footnote }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{
      margin: '0 0 20px',
      background: 'rgba(96, 165, 250, 0.06)',
      border: '1px solid rgba(96, 165, 250, 0.15)',
      borderRadius: 10,
      overflow: 'hidden',
    }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '12px 16px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#60a5fa',
          fontSize: '0.9rem',
          fontWeight: 600,
          fontFamily: 'inherit',
          textAlign: 'left',
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        How {moduleName} Works
        <span style={{ marginLeft: 'auto', fontSize: 12, color: '#7a8599', flexShrink: 0 }}>
          {open ? 'Hide' : 'Show guide'}
        </span>
      </button>

      {open && (
        <div style={{ padding: '0 16px 16px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 12,
          }}>
            {steps.map((s, idx) => (
              <div
                key={idx}
                style={{
                  padding: '14px 16px',
                  background: 'rgba(255,255,255,0.03)',
                  borderRadius: 8,
                  border: '1px solid rgba(255,255,255,0.06)',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <span style={{
                    width: 22, height: 22, borderRadius: '50%',
                    background: 'rgba(96,165,250,0.2)', color: '#60a5fa',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 700, flexShrink: 0,
                  }}>{idx + 1}</span>
                  <span style={{ color: '#e6f1ff', fontWeight: 600, fontSize: '0.85rem' }}>{s.title}</span>
                </div>
                <p style={{ color: '#8892a8', fontSize: '0.8rem', lineHeight: 1.5, margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>
          {footnote && (
            <p style={{ color: '#7a8599', fontSize: '0.75rem', margin: '12px 0 0', lineHeight: 1.5 }}>
              {footnote}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
